import React, { ReactElement } from 'react'
import { Redirect } from 'react-router-dom'

// ui-kit
import { SiteConfig } from '@navent-jobs/config'
import { useWindowSize } from '@navent-jobs/ui-kit/hooks/window-size'
import { RedirectHeaderMeta } from '@navent-jobs/ui-kit/components/redirect-prerender-meta'

// components
import SectionDetalle from './components/Sections/Detalle'
import SectionDescripcion from './components/Sections/Descripcion'
import SectionEmpresa from './components/Sections/Empresa'
import SectionsAvisosRelacionados from './components/Sections/AvisosRelacionados'
import FichaAvisoPlaceholderDesktop from './components/Placeholder/FichaAvisoPlaceholderDesktop'
import FichaAvisoPlaceholderMobile from './components/Placeholder/FichaAvisoPlaceholderMobile'
import FichaAvisoPlaceholderTabletPortrait from './components/Placeholder/FichaAvisoPlaceholderTabletPortrait'

// mixins
import { FichaWrapper, Separador } from './mixins'
import { SITE_ID } from '../../constants'
import features from '../../constants/features-per-country'

// features
const productBannersFeature = features[SITE_ID || 'BMAR'].marketplace?.banners?.enabled

const RedirectByWrongCountryId = ({ paisId }) => {
  const siteConfig = SiteConfig[SITE_ID]
  const ID_PAIS = siteConfig && siteConfig.pais && siteConfig.pais.id

  if (!paisId || !ID_PAIS) return null

  if (paisId !== ID_PAIS) {
    return (
      <>
        <RedirectHeaderMeta url="/404" contentCode="404" />
        <Redirect to="/404" />
      </>
    )
  }
  return null
}

interface FichaAvisoProps {
  aviso?: {
    descripcion: string
    requisitos: {}
    preguntas: [{}]
    origenAviso: string
    empresa: {
      id: string
      confidencial: boolean
      descripcion: string
      videoUrl: string
      industria: string
      ciudad: string
    }
    modalidadTrabajo: {
      id: number
    }
    localizacion: {
      paisId: number
    }
  }
  postulacion?: {
    fecha: string
    estado: string
  }
  productoLookAndFeel?: any
  urlMaker?: string
  desdeEmail?: any
  feria?: any
  nombreSitio: string
  loading?: boolean
  error?: boolean
  fichaAvisoService: {}
  mailService: {}
  dataLayers: {}
  inPageFichaAviso?: boolean
  postularme?: boolean
  stickyHeader?: boolean
  applicant?: {
    datosPersonales: {
      esPremium: boolean
    }
  }
  match: boolean
  postularBar?: ReactElement
  postulacionRapida?: boolean
}

const FichaAviso = ({ aviso, match, urlMaker, postularBar, postulacionRapida = false }: FichaAvisoProps) => {
  const { isMobile, isTabletPortrait, isTabletLandscape, isDesktop } = useWindowSize()
  const isDesktopOrTabletLandscape = isTabletLandscape || isDesktop
  const isAvisoSinFronteras = aviso?.modalidadTrabajo?.id === 4

  if (!aviso) {
    if (isMobile) {
      return <FichaAvisoPlaceholderMobile />
    }

    if (isTabletPortrait) {
      return <FichaAvisoPlaceholderTabletPortrait />
    }

    return <FichaAvisoPlaceholderDesktop />
  }

  return (
    <FichaWrapper>
      {!isAvisoSinFronteras && <RedirectByWrongCountryId paisId={aviso?.localizacion?.paisId} />}
      <>
        <div id="section-detalle">
          <div id="ficha-detalle">
            <SectionDetalle aviso={aviso} />
            <SectionDescripcion
              aviso={aviso}
              productBannersFeature={productBannersFeature}
              urlMaker={urlMaker}
              postulacionRapida={postulacionRapida}
              match={match}
            />
          </div>
          <div id="pre-postular-bar"></div>
          {postularBar}
          <Separador />
        </div>

        {!isDesktopOrTabletLandscape && (
          <div id="section-empresa">
            <SectionEmpresa aviso={aviso} />
          </div>
        )}

        <div id="section-avisos">
          <SectionsAvisosRelacionados />
        </div>
      </>
    </FichaWrapper>
  )
}

export default FichaAviso
